// SPDX-FileCopyrightText: Copyright (c) 2025 Software GmbH, Darmstadt, Germany and/or its subsidiaries and/or its affiliates
// SPDX-FileContributor: Zead Alshukairi (planen-bauen 4.0 GmbH)
// SPDX-FileContributor: Miguel Vega (planen-bauen 4.0 GmbH)
//
// SPDX-License-Identifier: Apache-2.0

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from 'src/app/construct-x/shared/services/language.service';
import { DidWebGeneratorComponent } from '../did-web-generator/did-web-generator.component';

@Component({
  selector: 'app-did-generator',
  templateUrl: './did-generator.component.html',
  styleUrls: ['./did-generator.component.scss'],
  imports: [
    TranslateModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    DidWebGeneratorComponent
  ]
})
export class DidGeneratorComponent implements OnInit {

  formGroup: FormGroup;
  //When true, embedded in another flow (e.g. SD wizard); success does not navigate away
  @Input() embeddedMode = false;
  @Output() didGenerated = new EventEmitter<void>();

  constructor(
    private fb: FormBuilder,
    private languageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
   if(this.embeddedMode) this.languageService.init('de');
    this.formGroup = this.fb.group({
      label: [''],
    });
  }

  onDidGenerated(): void {
    this.didGenerated.emit();
  }

  backToOverview(): void {
    void this.router.navigate(['../overview'], { relativeTo: this.route });
  }


  get label(): AbstractControl { return this.formGroup.get('label'); }

}
